<button mat-stroked-button 
  [ngClass]="{
    'no-border': noBorder,
    'primary': backgroundColor === 'primary',
    'secondary': backgroundColor === 'secondary'}"
  [style.min-width]="minWidth">

  <ng-content></ng-content>
</button>
